import { ProductHandle } from './ProductHandle.enum';

export type CompleteTheLookTag = `set-${ProductHandle}`;

export const ProductTags = [
  'no_service',
  'no_service_timed_sale',
  'return_unworn',
  'hidden_in_menus',
  'add_on',
  'collection_bestsellers',
  'collection_bras',
  'collection_tops',
  'collection_shapewear',
  'collection_bodysuits',
  'collection_underwear',
  'collection_bottoms',
  'featured_best_seller',
  'no_intimates_bag',
] as const;

export type ProductTag = typeof ProductTags[number] | CompleteTheLookTag;
